import {Store} from "@ngxs/store";
import {ActivatedRouteSnapshot, CanActivate, Router, UrlTree} from "@angular/router";
import {EventService} from "../../shared/services/event.service";
import {Injectable} from "@angular/core";
import {filter, map, Observable, take, combineLatest, catchError, of, switchMap} from "rxjs";
import {UserState} from "../../store/user/user.store";


@Injectable({ providedIn: 'root' })
export class EventRoleGuard implements CanActivate {
  constructor(
    private store: Store,
    private router: Router,
    private eventService: EventService
  ) { }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const eventId = route.paramMap.get("eventId");
    const requiredRoles: string[] = route.data["roles"] ?? [];
    const roleMode: "all" | "any" = route.data["roleMode"] ?? "all";

    // No event id to check the roles based on
    if (!eventId) return new Observable(sub => sub.next(true));

    if (!requiredRoles.length) return new Observable(sub => sub.next(true));

    return combineLatest([
      this.store.select(UserState.isAdmin),
      this.store.select(UserState.authUser),
    ]).pipe(
      filter(([isAdmin, authUser]) => authUser !== undefined),
      take(1),
      switchMap(([isAdmin, authUser]) => {
        if (!authUser) {
          console.debug("%c[RoleGuard] User is not logged in", 'color: red; background: orange;');
          return of(this.router.parseUrl("/"));
        }

        if (isAdmin) return of(true);

        return this.eventService.getEventRoles(+eventId).pipe(
          take(1),
          map((_eventRoles) => {
            const eventRoles: string[] = _eventRoles?.map((r: any) => r.name) ?? [];
            const allowed = roleMode === "all"
              ? requiredRoles.every(r => eventRoles.includes(r))
              : requiredRoles.some(r => eventRoles.includes(r));

            if (!allowed) {
              console.debug("%c[RoleGuard] User does not have required roles", 'color: red; background: orange;');
            }

            return allowed ? true : this.router.parseUrl("/");
          }),
          catchError(() => of(false))
        );
      })
    );
  }
}